import { createStore } from '@orderx/lab/xr/store';
import { MenuProduct } from '../XV2';

const { useStore } = createStore<{
    menuProduct: MenuProduct;
    orderProductId?: number;
}>({
    menuProduct: undefined as any,
    orderProductId: undefined,
});

export function useOrderProductOverlay() {
    const [state, setState] = useStore();

    return {
        ...state,

        reset() {
            setState({} as any);
        },

        setProduct(menuProduct: MenuProduct, orderProductId?: number) {
            setState((state) => {
                state.menuProduct = menuProduct;
                state.orderProductId = orderProductId;
            });
        },
    };
}
